import clsx from "clsx";

import styles from "./policies-hero.module.css";

const POLICY_HERO_ILLUSTRATION = "/assets/images/policy_icon.png";

export type PoliciesHeroProps = {
  title?: string;
  subtitle?: string;
};

export function PoliciesHero({
  title = "Policies",
  subtitle = "Company policies and guidelines",
}: PoliciesHeroProps) {
  return (
    <section className={styles.hero} aria-labelledby="policies-hero-heading">
      <div className={styles.row}>
        <div className={styles.copy}>
          <h1 id="policies-hero-heading" className={clsx("heading-lg", styles.title)}>
            {title}
          </h1>
          {subtitle ? (
            <p className={clsx("sub-heading-sm", styles.subtitle)}>{subtitle}</p>
          ) : null}
        </div>
        <div className={styles.art} aria-hidden>
          <img
            src={POLICY_HERO_ILLUSTRATION}
            alt=""
            className={styles.heroImg}
            width={320}
            height={160}
            decoding="async"
          />
        </div>
      </div>
    </section>
  );
}
